import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./lib/auth";
import { Toaster } from "./components/ui/sonner";

import Landing from "./pages/Landing";
import Marketplace from "./pages/Marketplace";
import BusinessDetail from "./pages/BusinessDetail";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import AdminPanel from "./pages/AdminPanel";
import SellerPanel from "./pages/SellerPanel";
import InvestorPanel from "./pages/InvestorPanel";
import Terminos from "./pages/Terminos";
import Privacidad from "./pages/Privacidad";
import Confidencialidad from "./pages/Confidencialidad";
import Contacto from "./pages/Contacto";
import ScrollToTop from "./components/ScrollToTop";
import { toast } from "sonner";
import { useEffect } from "react";

function ProtectedRoute({ children, roles }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function PublicarRedirect() {
  const { user } = useAuth();
  useEffect(() => {
    if (user?.role === "investor") {
      toast.info("Para publicar un negocio necesitas una cuenta de Vendedor. Regístrate como vendedor o cambia de cuenta.", { duration: 6000 });
    }
  }, [user?.role]);
  if (!user) return <Navigate to="/login" state={{ from: "/seller/new" }} replace />;
  if (user.role === "investor") return <Navigate to="/register?role=seller" replace />;
  return <Navigate to="/seller/new" replace />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/marketplace" element={<Marketplace />} />
          <Route path="/business/:slug" element={<BusinessDetail />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/publicar" element={<PublicarRedirect />} />
          <Route path="/como-funciona" element={<Navigate to="/#como-funciona" replace />} />
          <Route path="/terminos" element={<Terminos />} />
          <Route path="/privacidad" element={<Privacidad />} />
          <Route path="/confidencialidad" element={<Confidencialidad />} />
          <Route path="/contacto" element={<Contacto />} />

          <Route path="/admin/*" element={
            <ProtectedRoute roles={["super_admin"]}><AdminPanel /></ProtectedRoute>
          } />
          <Route path="/seller/*" element={
            <ProtectedRoute roles={["seller", "super_admin"]}><SellerPanel /></ProtectedRoute>
          } />
          <Route path="/investor/*" element={
            <ProtectedRoute roles={["investor", "super_admin"]}><InvestorPanel /></ProtectedRoute>
          } />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
